import type { ReactNode } from 'react';
import { Titre } from './Titre';

/**
 * **Un état vide DIT CE QU'IL FAUT FAIRE**, et c'est une règle du corpus, pas du goût.
 *
 * `CDC-4` F-54 : « **trois états vides, chacun disant ce qu'il faut faire** : aucun cours
 * passé ; aucune relation ; aucun cours en train de se dérouler. »
 *
 * **ET UN QUATRIÈME QUI LEUR RESSEMBLE SANS EN ÊTRE UN** : « l'espace d'une personne sans
 * rattachement n'est pas l'un des trois : celui-là dit **aucun cours POSSIBLE**, les trois
 * autres disent *aucun cours*. **Ce sont deux écrans différents sous une même
 * apparence**, et l'étape de maquettage doit les distinguer. » C'est le champ `accesPerdu`
 * de l'écran d'arrivée qui les sépare, et c'est à l'appelant de choisir le texte — ce
 * composant ne devine pas.
 */
type Props = {
  readonly titre: string;
  readonly children: ReactNode;
  /** Ce qu'il faut faire. Absent quand il n'y a précisément rien à faire. */
  readonly action?: ReactNode;
};

export function EtatVide({ titre, children, action }: Props) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-4 bg-fond-surface px-6 py-12 text-center">
      <Titre niveau={2} taille="20">
        {titre}
      </Titre>
      <p className="max-w-[52ch] text-16 leading-normal text-texte-faible">
        {children}
      </p>
      {action}
    </div>
  );
}
